import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { clearMsg } from '@blade-sxp/monitor/api/msg/index';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
import { EventBus, EventKeys } from '@blade/common';
import MsgBoard from '@blade-sxp/monitor/components/msg/board.vue';
import taskType from '@blade-sxp/monitor/lang/task-type';
import { getAlertFont } from '@blade-sxp/monitor/utils/transforms';
import { HandlealarmMapDetails } from '@blade/common/store/alarm-map';
import { AlarmMsgModule } from '@blade-sxp/monitor/store/alarm-msg';
let MsgAlarm = class MsgAlarm extends Vue {
    unreadNum = 0;
    badge = true;
    MAX_UNREAD_NUMBER = 99;
    msgDraw = false;
    ws;
    wsUrl = '';
    msgList = [];
    viewMsgList = [];
    get alarmId() {
        return HandlealarmMapDetails.handleId;
    }
    get messageSwitch() {
        return AlarmMsgModule.messageSwitch;
    }
    get tipsShow() {
        return AlarmMsgModule.tipsShow;
    }
    get topping() {
        return AlarmMsgModule.topping;
    }
    onUpdateMsgList() {
        AlarmMsgModule.updateAlertList(this.msgList);
    }
    async onChangeAlarmId(val) {
        await this.getAlarmList();
    }
    onTopping(val) {
        if (val && this.messageSwitch) {
            this.getViewNow();
        }
        else if (!val && this.messageSwitch) {
            this.unreadNum = 0;
            this.badge = true;
        }
    }
    created() {
        this.wsUrl =
            process.env.NODE_ENV === 'development' ? process.env.VUE_APP_MSG_WS : `wss://${window.location.host}/${process.env.VUE_APP_MSG_WS}`;
    }
    mounted() {
        this.initWebSocket();
        EventBus.$on(EventKeys.Logout, () => this.ws?.close());
    }
    deleteDetails(val) {
        this.duplicateRemoval(val);
    }
    getAlarmList() {
        this.msgList = this.msgList.filter((item) => item.id !== this.alarmId);
        this.viewMsgList = this.viewMsgList.filter((item) => item.id !== this.alarmId);
        this.unreadNum = 0;
    }
    async getViewNow() {
        await this.msgList.unshift(...this.viewMsgList);
        if (this.msgList.length > 30) {
            this.msgList = this.msgList.slice(0, 30);
        }
        this.viewMsgList = [];
        this.badge = true;
    }
    changeBadgeShow(val) {
        this.unreadNum = 0; // 消息推送开关 变化时 小铃铛数量清零。
        if (this.messageSwitch && this.unreadNum > 0) {
            if (this.topping) {
                this.badge = false;
            }
            else {
                this.badge = true;
            }
        }
        else {
            this.badge = true;
        }
    }
    // 去重
    duplicateRemoval(val) {
        const curIdx = this.msgList.findIndex((item) => item.id === val);
        if (curIdx !== -1) {
            this.msgList.splice(curIdx, 1);
        }
    }
    websocketonmessage(e) {
        if (!/({.*})|(\[.*\])/g.test(e.data))
            return;
        EventBus.$emit('alarm', JSON.stringify(JSON.parse(String.raw `${e.data}`)));
        let msgArr = JSON.parse(e.data);
        if (msgArr.incidentStatus !== 'CONTINUE') {
            this.duplicateRemoval(msgArr.id);
        }
        let localArr = [];
        if (msgArr.incidentStatus !== 'DELETE') {
            localArr.unshift(msgArr);
        }
        this.unreadNum = this.unreadNum + 1;
        localArr = localArr.map((item) => {
            const { taskType, alertType } = item;
            const alertFont = this.$t(getAlertFont(taskType, alertType));
            return {
                ...item,
                alertFont,
            };
        });
        if (this.messageSwitch) {
            if (this.topping) {
                if (this.unreadNum && this.unreadNum > 0) {
                    this.badge = false;
                }
                this.msgList.unshift(...localArr);
            }
            else {
                this.badge = true;
                this.viewMsgList.unshift(...localArr);
            }
        }
        else {
            this.badge = true;
            this.viewMsgList.unshift(...localArr);
        }
        this.msgList = this.msgList.map((item) => {
            item['dateDiff'] = this.getDateDiff(item.alertTime);
            return { ...item };
        });
        this.viewMsgList = this.viewMsgList.map((item) => {
            item['dateDiff'] = this.getDateDiff(item.alertTime);
            return { ...item };
        });
        if (this.viewMsgList.length > 100) {
            this.viewMsgList = this.viewMsgList.slice(0, 100);
        }
        if (this.msgList.length > 30) {
            this.msgList = this.msgList.slice(0, 30);
        }
    }
    getDateDiff(val) {
        const dateDiff = Date.now() - val;
        let minutes = Math.floor(dateDiff / 1000);
        if (minutes < 1) {
            minutes = 1;
        }
        return minutes;
    }
    initWebSocket() {
        const subProtocol = window?.keycloak_token;
        this.ws = new AlarmWebsocket(this.wsUrl, subProtocol);
        this.ws.setOnMessage(this.websocketonmessage);
    }
    darwClose() {
        this.unreadNum = 0;
        this.badge = true;
        this.msgDraw = false;
        this.msgList = [];
        this.viewMsgList = [];
        AlarmMsgModule.getTopping(true);
        AlarmMsgModule.getTipsShow(false);
    }
    clearMsgNum() {
        clearMsg().then((res) => {
            this.unreadNum = res.data.data.unreadNum;
            this.badge = true;
        });
    }
    drawShow() {
        this.msgDraw = true;
        this.clearMsgNum();
    }
};
__decorate([
    Watch('msgList', { immediate: true, deep: true })
], MsgAlarm.prototype, "onUpdateMsgList", null);
__decorate([
    Watch('alarmId')
], MsgAlarm.prototype, "onChangeAlarmId", null);
__decorate([
    Watch('topping')
], MsgAlarm.prototype, "onTopping", null);
MsgAlarm = __decorate([
    Component({
        name: 'MsgAlarm',
        components: { MsgBoard },
        i18n: {
            sharedMessages: taskType,
        },
    })
], MsgAlarm);
export default MsgAlarm;
